import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  Home, 
  Sun, 
  Heart, 
  Dumbbell, 
  Briefcase, 
  Users, 
  Book, 
  GraduationCap 
} from "lucide-react";

export default function Categories() {
  const navigate = useNavigate();

  const categories = [
    { name: "Indoor", icon: <Home className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "Outdoor", icon: <Sun className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "Wedding", icon: <Heart className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "Gym", icon: <Dumbbell className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "Office", icon: <Briefcase className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "Meeting", icon: <Users className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "School", icon: <Book className="h-8 w-8 text-[#D4AF37]" /> },
    { name: "College", icon: <GraduationCap className="h-8 w-8 text-[#D4AF37]" /> },
  ];

  const handleCategoryClick = (categoryName) => {
    // Navigate to shopping page with category filter applied
    navigate('/shop', { 
      state: { 
        selectedCategory: categoryName 
      } 
    });
  };

  return (
    <>
      {/* Inline CSS for animations and styling */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .category-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            cursor: pointer;
          }
          .category-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
          }
          .category-card:active {
            transform: translateY(-3px);
          }
          .category-icon {
            transition: transform 0.3s ease;
          }
          .category-card:hover .category-icon {
            transform: scale(1.1);
          }
        `}
      </style>

      <section className="py-12 px-4 md:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-10">
            <h2
              className="text-3xl md:text-4xl text-[#333333] mb-2 tracking-wide"
              style={{ fontFamily: "serif" }}
            >
              Categories
            </h2>
            <div className="flex justify-center items-center gap-2">
              <div className="h-1 w-8 bg-[#D4AF37] rounded-full"></div>
              <div className="h-1 w-2 bg-[#D4AF37] rounded-full"></div>
              <div className="h-1 w-2 bg-[#D4AF37] rounded-full"></div>
            </div>
            <p className="text-gray-600 text-md mt-3">
              Explore through our Product Categories. Grab what you want.
            </p>
          </div>

          {/* Categories Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
            {categories.map((category, index) => (
              <div
                key={category.name}
                className="category-card flex flex-col items-center p-4 bg-white rounded-full shadow-md hover:bg-gray-50"
                style={{ 
                  animation: `fadeInUp 0.5s ease-out ${index * 0.1}s forwards`, 
                  opacity: 0 
                }}
                onClick={() => handleCategoryClick(category.name)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleCategoryClick(category.name);
                  }
                }}
                aria-label={`Shop ${category.name} products`}
              >
                <div className="category-icon mb-3">{category.icon}</div>
                <h3 className="text-sm font-medium text-[#333333] uppercase text-center">
                  {category.name}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}